var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "modal",
        {
          staticClass:
            "modal-view--bg modal-view--page-search modal-view--with-icon",
          attrs: { closeOnClick: true, title: _vm.title, isOpen: true },
          on: { close: _vm.closeModal }
        },
        [
          _vm.titleIcon
            ? _c("filter-icons", {
                attrs: { slot: "icon", icon: _vm.titleIcon },
                slot: "icon"
              })
            : _vm._e(),
          _vm._v(" "),
          _c("page-search-widget", {
            attrs: { queryParams: _vm.searchQueryParams },
            on: {
              shownselector: function(s) {
                return (_vm.selectorShown = s)
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba89aa0e", { render: render, staticRenderFns: staticRenderFns })
  }
}